<template lang="pug">
div
  template(v-if="!pageLoading")
    .gbox(ref="container")
      #preloader(v-if="gameLaunching")
        #loader
      div(v-if="!pageLoading")
        .ggl
          a(href="javascript:void(0)" @click='launchDs88')
            img.img-fluid.game-img(src='assets/img/provider/ds88.png')
            span ds88
        .ggl
          a(href="javascript:void(0)" @click='launchIronclaw')
            img.img-fluid.game-img(src='assets/img/provider/ironclaw.png')
            span IronClaw
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading: false,
      gameLaunching:false,
      
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    }
  },
  destroyed(){
    // window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    // window.scroll(0,0)
    // this.getProviderGameOfflist()
    // var vm = this
    // window.addEventListener('scroll', this.loadItems)
    // $("*").scroll(function(e) {
    //   vm.loadItems()
    // });
  },
  methods:{ 
    launchDs88(){
      if (this.sessionToken) {
        this.$router.push({
          name:"lobby",
          params:{
            "source": "sabong",
            "type": "SABONG",
            "provider": "",
            "code": "DS88",
            "id": "",
            "name": "name"
          }
        }).catch(error =>{})
        // this.gameLaunching = true
        // var vm = this
        // let player_id = this.accountID
        // let auth_token = this.sessionToken
        // let lang_code = "en"
        // this.$store
        //   .dispatch("user/launchSabong", { player_id, auth_token, lang_code })
        //   .then(response => {
        //     if (response.success == true) {
        //       setTimeout(() => {
        //         window.open(response.data, "_blank")
        //         vm.gameLaunching = false
        //       }) 
        //     } else {
        //       vm.gameLaunching = false        
        //       if((typeof response.status) != 'object'){
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
        //       }
        //     }
        //   })
        //   .catch(response => {
        //     vm.gameLaunching = false
        //     if((typeof response.status) != 'object'){
        //       if(response.status === 'free_credit_detected'){
        //         this.$swal({
        //           title: vm.$tc("ui.attention"),
        //           text: vm.$tc("message.list.free_credit_detected"),
        //           showCancelButton: true,
        //           type: "info",
        //           confirmButtonText: vm.$tc("ui.ok"),
        //           cancelButtonText: vm.$tc("ui.deposit"),
        //         }).then(result => {
        //           if (result.value) {
        //             vm.$router.push("/").catch(error =>{})
        //             // 
        //           } else if (result.dismiss) {
        //             if(result.dismiss === 'cancel'){
        //               vm.$router.push("/deposit").catch(error =>{})
        //             }
        //           }
        //         });
        //       }else{
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
        //       }
        //     }
        //   });
      }else{
        $("#logModal").modal("show")
      }
    },
    launchIronclaw(){
      if (this.sessionToken) {
        this.$router.push({
          name:"lobby",
          params:{
            "source": "sabong",
            "type": "SABONG",
            "provider": "",
            "code": "IRONCLAW",
            "id": "",
            "name": "name"
          }
        }).catch(error =>{})
        // this.gameLaunching = true
        // var vm = this
        // let player_id = this.accountID
        // let auth_token = this.sessionToken
        // let lang_code = "en"
        // this.$store
        //   .dispatch("user/launchIronclaw", { player_id, auth_token, lang_code })
        //   .then(response => {
        //     if (response.success == true) {
        //       setTimeout(() => {
        //         window.open(response.data, "_blank")
        //         vm.gameLaunching = false
        //       }) 
        //     } else {
        //       vm.gameLaunching = false        
        //       if((typeof response.status) != 'object'){
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
        //       }
        //     }
        //   })
        //   .catch(response => {
        //     vm.gameLaunching = false
        //     if((typeof response.status) != 'object'){
        //       if(response.status === 'free_credit_detected'){
        //         this.$swal({
        //           title: vm.$tc("ui.attention"),
        //           text: vm.$tc("message.list.free_credit_detected"),
        //           showCancelButton: true,
        //           type: "info",
        //           confirmButtonText: vm.$tc("ui.ok"),
        //           cancelButtonText: vm.$tc("ui.deposit"),
        //         }).then(result => {
        //           if (result.value) {
        //             vm.$router.push("/").catch(error =>{})
        //             // 
        //           } else if (result.dismiss) {
        //             if(result.dismiss === 'cancel'){
        //               vm.$router.push("/deposit").catch(error =>{})
        //             }
        //           }
        //         });
        //       }else{
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
        //       }
        //     }
        //   });
      }else{
        $("#logModal").modal("show")
      }
    },
  }
}
</script>
